// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
    image.style.visibility = 'hidden'; // Hide original so only zoomed overlay is visible
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundRepeat = 'no-repeat';
  container.style.backgroundColor = '#F8F2E6'; // Solid havenne_bg - no transparency
  container.style.mixBlendMode = 'multiply';
  container.style.position = 'absolute';
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = '100%';
  container.style.height = '100%';
  container.style.zIndex = '10';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function removeOverlay(overlay, image) {
  overlay.remove();
  if (image) image.style.visibility = '';
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => removeOverlay(overlay, image);
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => removeOverlay(overlay, image);
}

function attachZoomToImage(image, zoomRatio) {
  // Skip if already attached
  if (image.dataset.zoomAttached === 'true') return;
  image.dataset.zoomAttached = 'true';

  image.addEventListener('click', (event) => {
    // Only zoom if image is visible
    if (
      window.getComputedStyle(image).display !== 'none' &&
      window.getComputedStyle(image).visibility !== 'hidden' &&
      image.offsetParent !== null
    ) {
      event.stopPropagation();
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    }
  });
}

function enableZoomOnHover(zoomRatio) {
  // Attach to all existing images
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    attachZoomToImage(image, zoomRatio);
  });

  // Use MutationObserver to attach to dynamically added images
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Element node
          // Check if the added node is an image with zoom class
          if (node.classList && node.classList.contains('image-magnify-hover')) {
            attachZoomToImage(node, zoomRatio);
          }
          // Check for images inside the added node
          const images = node.querySelectorAll && node.querySelectorAll('.image-magnify-hover');
          if (images) {
            images.forEach((image) => attachZoomToImage(image, zoomRatio));
          }
        }
      });
    });
  });

  // Observe the entire document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// Wait for DOM to be ready before initializing
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => enableZoomOnHover(2));
} else {
  enableZoomOnHover(2);
}
